var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view-funiswap std-view"},[(!_vm.currentAccount)?[_c('f-message',{attrs:{"type":"error","alert":"","with-icon":""}},[_vm._v("Bad wallet")])]:[_c('main',{staticClass:"main"},[_c('h1',{attrs:{"data-focus":""}},[_vm._v("fUNI")]),_c('f-uniswap-menu'),_c('router-view')],1)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }